import _ from 'lodash'
import React from 'react'
import moment from 'moment'
import axios from 'axios'
import config from '../../variables/config'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { sendRequest } from '../../modules/admin'
import { fetchUseractions, createAction } from '../../modules/useractions'
import {
  changeFinished,
  newUserNotRequired,
  fetchAll,
  fetchLatest,
  unsubscribeMember,
  previewMember
} from '../../modules/users'
import './checkmember.scss'
import Alert from '../views/alert'
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'
import domtoimage from 'dom-to-image'

const checkmemberText = 'Check membership'
const tryAgainText = 'Please try again later'
const errorText = 'Error'
const loadingText = 'Loading'
const pleaseSelectUText = 'Please select a user'
const searchText = 'Search'
const changeText = 'Change'
const membershipText = 'Membership'
const noMemberText = 'No membership'
const memberTypeText = 'Membership type'
const startDateText = 'Start date'
const cancelText = 'Unsubscribe'
const memberIntervalText = 'Membership interval'
const statusText = 'Status'
const previewText = 'Preview'
const downloadText = 'Download'
const referenceText = 'Reference'
const lastPaymentText = 'Last payment on'
const paymentStatusText = 'Last payment status'
// const expiredText = 'Expired';
const membershipBText = 'MEMBERSHIP'
const termsText = 'Terms and Conditions Apply'
const termsSubText =
  'The membership card id non-transferable under any circumstances.'
const companyText = 'Wacky Kingdom Soft Play Centre'
const telText = 'Tel: '
const emailText = 'Email: '
const telephoneText = '01737 763 523'
const emailAddressText = 'info@wackykingdom.com'
const guardiansText = 'Guardians'
const firstNameText = 'First Name'
const lastNameText = 'Last Name'
const yesText = 'Yes'
const siblingText = 'Sibling'
const familyPlanText = 'Family plan'
const childrenOnPlanText = 'Children covered'
const clockinText = 'Clock in'
const clockoutText = 'Clock out'
const clockinAtText = 'Latest clock in'
const clockoutAtText = 'Latest clock out'
const guestPassesRemainingText = 'Guest passes remaining'
const guestPassUseButtonText = 'Use guest pass'
const noGuestPassesText = 'No guest passes remaining.'

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => {}
}
// selected: false,
// user: {},
// extraParams: {},
// image: '',
// previewSelected: true
class Checkmember extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      alert: _.clone(emptyAlert),
      selectedUser: {
        selected: false,
        user: {},
        extraParams: {},
        image: '',
        previewSelected: true
      },
      guestPass: 0,
      search: '',
      searchResults: [],
      hasSearched: false
    }
  }

  componentDidMount = () => {
    this.props.sendRequest(fetchAll)
    this.props.sendRequest(fetchLatest)
    this.props.sendRequest(fetchUseractions)
  }

  clockAction = type => {
    const data = {
      type: type,
      userId: this.state.selectedUser.user.id
    }

    this.props.sendRequest(createAction, data)
  }

  cancel = async () => {
    this.props.sendRequest(unsubscribeMember, {
      id: this.state.selectedUser.user.membership.id
    })
  }

  getGuestPassRemaining = () => {
    const m = this.state.selectedUser.membership
    const g = this.state.guestPass
    if (typeof g === 'number') return g
    if (m && typeof m.guestPass === 'number') return m.guestPass
    return 0
  }

  updateGuestPass = async () => {
    const membership = this.state.selectedUser.membership
    if (!membership || !membership.id) return

    const remainingBefore = this.getGuestPassRemaining()
    if (remainingBefore <= 0) {
      this.setState({
        alert: {
          showAlert: true,
          message: noGuestPassesText,
          type: 'warning',
          callback: () => this.setState({ alert: _.clone(emptyAlert) })
        }
      })
      return
    }

    try {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      const { data } = await axios.post(
        config.serverURL +
          '/memberships/removeGuestPasses?access_token=' +
          token,
        { membershipId: membership.id, count: 1 }
      )
      const remaining = data.guestPass
      const su = this.state.selectedUser
      this.setState({
        selectedUser: {
          ...su,
          user: su.user.membership
            ? {
                ...su.user,
                membership: { ...su.user.membership, guestPass: remaining }
              }
            : su.user,
          membership: { ...su.membership, guestPass: remaining }
        },
        guestPass: remaining
      })
      if (!data.removed) {
        this.setState({
          alert: {
            showAlert: true,
            message: noGuestPassesText,
            type: 'warning',
            callback: () => this.setState({ alert: _.clone(emptyAlert) })
          }
        })
      }
    } catch (error) {
      console.log('checkmember - removeGuestPasses:', error.message)
      this.setState({
        alert: {
          showAlert: true,
          message: tryAgainText,
          type: 'error',
          callback: () => this.setState({ alert: _.clone(emptyAlert) })
        }
      })
    }
  }

  preview = async () => {
    if (this.state.previewSelected && this.props.image !== '') {
      var nodes = document.querySelectorAll('.frontSide')
      for (var i in nodes) {
        var node = nodes[i]
        if (typeof node !== 'object') {
          break
        }
        this.saveFile(node, i)
      }
      this.generateCardSid()
    } else {
      this.setState({ previewSelected: true })
      this.props.sendRequest(previewMember, {
        id: this.state.selectedUser.user.membership.id
      })
    }
  }

  saveFile = async (node, i) => {
    const dataUrl = await domtoimage.toPng(node)
    var img = new Image()
    img.src = dataUrl
    const response = await fetch(dataUrl)
    const blob = await response.blob()
    var a = document.createElement('a')
    a.href = window.URL.createObjectURL(blob)
    a.download = 'card' + (Number(i) + 1) + '.png'
    a.click()
  }

  generateCardSid = () => {
    var cardSide = document.createElement('div')
    cardSide.className = 'generateSide'

    var logo = document.createElement('img')
    logo.className = 'logoImage'
    logo.src = require('./logo.png')

    var elementOne = document.createElement('div')
    elementOne.className = 'membershipType'

    var memberType = document.createElement('div')
    memberType.className = 'textBold'
    memberType.innerHTML = this.state.selectedUser.membership.type.toUpperCase()

    elementOne.append(memberType)
    elementOne.innerHTML += '&nbsp;' + membershipBText

    var elementTwo = document.createElement('div')
    elementTwo.className = 'whiteBackground'

    var image = document.createElement('img')
    image.className = 'previewImage'
    image.src = this.props.image

    var reference = document.createElement('div')
    reference.className = 'cardReference'
    reference.innerHTML = this.state.selectedUser.membership.reference

    elementTwo.append(image)
    elementTwo.append(reference)

    var elementThree = document.createElement('div')
    elementThree.className = 'whiteBackgroundSmall'
    elementThree.innerHTML =
      this.state.selectedUser.user.firstName +
      ' ' +
      this.state.selectedUser.user.lastName

    var elementFour = document.createElement('div')
    elementFour.className = 'backsideDetails'

    var textOne = document.createElement('div')
    textOne.className = 'detailsText bold'
    textOne.innerHTML = termsText

    var textTwo = document.createElement('div')
    textTwo.className = 'detailsText'
    textTwo.innerHTML = termsSubText

    var textThree = document.createElement('div')
    textThree.className = 'detailsMargin'

    var textFour = document.createElement('div')
    textFour.className = 'detailsText bold'
    textFour.innerHTML = companyText

    var textFive = document.createElement('div')
    textFive.className = 'detailsText'

    var subTextOne = document.createElement('div')
    subTextOne.className = 'bold'
    subTextOne.innerHTML = emailText

    textFive.append(subTextOne)
    textFive.innerHTML += '&nbsp;' + emailAddressText

    var textSix = document.createElement('div')
    textSix.className = 'detailsText'

    var subTextTwo = document.createElement('div')
    subTextTwo.className = 'bold'
    subTextTwo.innerHTML = telText

    textSix.append(subTextTwo)
    textSix.innerHTML += '&nbsp;' + telephoneText

    elementFour.append(textOne)
    elementFour.append(textTwo)
    elementFour.append(textThree)
    elementFour.append(textFour)
    elementFour.append(textFive)
    elementFour.append(textSix)

    cardSide.appendChild(logo)
    cardSide.appendChild(elementOne)
    cardSide.appendChild(elementTwo)
    cardSide.appendChild(elementThree)
    cardSide.appendChild(elementFour)

    var hideBackground = document.createElement('div')
    hideBackground.className = 'generateSide greenBackground'

    var showHolder = document.createElement('div')
    showHolder.className = 'showHolder'

    showHolder.appendChild(cardSide)
    showHolder.appendChild(hideBackground)

    var loadCheck = [false, false]
    const complete = () => {
      var nodes = document.querySelectorAll('.checkmemberForm')
      nodes[0].appendChild(showHolder)
      this.saveFile(cardSide, 1)
    }

    image.onload = () => {
      if (loadCheck[1]) {
        complete()
      } else {
        loadCheck[0] = true
      }
    }

    logo.onload = () => {
      if (loadCheck[0]) {
        complete()
      } else {
        loadCheck[1] = true
      }
    }
  }

  fetchSubscription = async membership => {
    try {
      if (
        membership &&
        membership.subscriptionId &&
        membership.subscriptionId !== ''
      ) {
        let token = JSON.parse(window.localStorage.getItem('userData')).token

        const newMembership = (await axios.get(
          config.serverURL +
            '/Memberships/' +
            membership.id +
            '?access_token=' +
            token
        )).data

        const params = {
          subscriptionId: membership.subscriptionId
        }

        const subscription = (await axios.post(
          config.serverURL + '/subscriptionGet' + '?access_token=' + token,
          params
        )).data
        const extraParams = {
          isActive: subscription.status === 'active',
          endDate: moment
            .unix(subscription.current_period_end)
            .format('DD/MM/YYYY')
        }
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            extraParams: extraParams
          },
          guestPass: newMembership.guestPass
        })
      } else if (membership) {
        var startDate = moment(membership.startDate)
        startDate.add(12, 'M')
        let token = JSON.parse(window.localStorage.getItem('userData')).token
        const newMembership = (await axios.get(
          config.serverURL +
            '/Memberships/' +
            membership.id +
            '?access_token=' +
            token
        )).data

        const extraParams = {
          isActive: false,
          endDate: startDate.format('DD/MM/YYYY')
        }

        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            extraParams: extraParams
          },
          guestPass: newMembership.guestPass
        })
      }
    } catch (error) {
      console.log('checkmember - fetchSubscription:', error.message)
    }
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  getText = () => {
    if (this.props.requestFailed) {
      return errorText
    } else if (this.props.requestLoading) {
      return loadingText
    } else {
      return checkmemberText
    }
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert} />
    } else if (this.props.requestFailed) {
      var alert = _.clone(emptyAlert)
      alert.type = 'error'
      alert.showAlert = true
      alert.message = tryAgainText
      alert.callback = () => {
        this.props.changeFinished()
      }

      return <Alert alert={alert} />
    } else if (this.props.requestFinished) {
      var alert2 = _.clone(emptyAlert)
      alert2.type = 'success'
      alert2.showAlert = true
      alert2.callback = () => {
        this.props.changeFinished()
        this.animateClose()
      }

      return <Alert alert={alert2} />
    } else {
      return void 0
    }
  }

  animateCloseOpen = completed => {
    this.setState({ previewSelected: false })
    var redirect = this.props.userForBooking.redirect
    if (this.props.userForBooking.required && !completed)
      this.props.newUserNotRequired()
    this.setState(
      {
        shouldClose: true
      },
      () => {
        setTimeout(() => {
          this.props.closeOpenWindow(redirect)
        }, 500)
      }
    )
  }

  animateClose = () => {
    this.setState({ previewSelected: false })
    if (this.props.userForBooking.required) this.props.newUserNotRequired()

    this.setState(
      {
        shouldClose: true
      },
      () => {
        setTimeout(() => {
          this.props.closeWindow()
        }, 500)
      }
    )
  }

  selectUser = async user => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    let newMembership
    if (user.membership) {
      newMembership = (await axios.get(
        config.serverURL +
          '/Memberships/' +
          user.membership.id +
          '?access_token=' +
          token
      )).data
    }
    this.setState(
      {
        selectedUser: {
          user: user,
          selected: true,
          extraParams: {},
          membership: user.membership
        },
        guestPass: newMembership ? newMembership.guestPass : 0
      },
      () => {
        this.fetchSubscription(user.membership)
      }
    )
  }

  unselectUser = () => {
    this.setState({
      previewSelected: false,
      selectedUser: {
        user: {},
        selected: false
      }
    })
  }

  filterSearchItems = () => {
    var items = _.clone(this.props.users)
    var search = this.state.search
    return items.filter(item => {
      if (!item || !item.membership) return false
      if (
        item.firstName &&
        item.firstName.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      if (
        item.lastName &&
        item.lastName.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      if (
        item.email &&
        item.email.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      if (
        item.membership.reference &&
        item.membership.reference.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      return false
    })
  }

  runSearch = () => {
    var items = []
    if (this.state.search === '') {
      items = Array.isArray(this.props.recentUsers)
        ? this.props.recentUsers
        : []
      items = items.filter(item => item && item.membership)
    } else {
      items = this.filterSearchItems()
    }

    this.setState({
      searchResults: items,
      hasSearched: true
    })
  }

  getSearchItems = () => {
    if (!this.state.hasSearched) return null

    const filtered = this.state.searchResults
    if (!filtered.length) {
      return (
        <div className="searchWrapper searchBorder">
          <div className="searchRow smallText noBorder">No memberships found</div>
        </div>
      )
    }

    return (
      <div className="searchWrapper searchBorder searchResultsList">
        {filtered.map((item, index) => {
          const membership = item.membership || {}
          const guestPasses =
            typeof membership.guestPass === 'number' ? membership.guestPass : 0
          return (
            <div
              className={
                'searchRow smallText' +
                (index + 1 === filtered.length ? ' noBorder' : '')
              }
              key={item.id || index}
              onClick={() => this.selectUser(item)}>
              <div>
                {item.firstName + ' ' + item.lastName} -{' '}
                {item.adminId ? 'SITE' : 'ONLINE'}
              </div>
              <div>{item.email}</div>
              <div>
                <b>{statusText + ': ' + (membership.status || '')}</b>
              </div>
              <div>
                {memberTypeText + ': '}
                {membership.type || 'N/A'}
              </div>
              <div>
                {memberIntervalText + ': '}
                {membership.interval || 'N/A'}
              </div>
              <div>
                {familyPlanText + ': '}
                {membership.isFamily ? yesText : 'No'}
              </div>
              <div>
                {childrenOnPlanText + ': '}
                {membership.isFamily && membership.familyChildCount != null
                  ? membership.familyChildCount
                  : 'N/A'}
              </div>
              <div>
                {startDateText + ': '}
                {membership.startDate
                  ? moment(membership.startDate).format('DD/MM/YYYY')
                  : 'N/A'}
              </div>
              <div>
                {referenceText + ': '}
                {membership.reference || 'N/A'}
              </div>
              <div>
                {guestPassesRemainingText + ': '}
                {guestPasses}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  handleMemberChange = (property, e) => {
    var value = e.target.value
    if (property === 'hasDirectDebit') value = value === 'Yes' ? true : false

    this.setState({
      selectedUser: {
        ...this.state.selectedUser,
        membership: {
          ...this.state.selectedUser.membership,
          [property]: value
        }
      },
      guestPass:
        this.state.guestPass > 0
          ? this.state.guestPass
          : this.state.selectedUser.membership.guestPass
    })
  }

  getLastPayment = () => {
    if (
      !this.state.selectedUser.membership.lastPayment ||
      this.state.selectedUser.membership.lastPayment === null
    ) {
      return <div></div>
    }

    return [
      <div className="amountInputRow" key={0}>
        <div>{lastPaymentText + ':'}</div>
        <div>
          {moment(
            this.state.selectedUser.membership.lastPayment.charge_date
          ).format('DD/MM/YYYY')}
        </div>
      </div>,
      <div className="amountInputRow" key={1}>
        <div>{paymentStatusText + ':'}</div>
        <div>{this.state.selectedUser.membership.lastPayment.status}</div>
      </div>
    ]
  }

  getLatestClockIn = () => {
    var userActions = this.props.useractions.filter(
      action => action.userId === this.state.selectedUser.user.id
    )

    var latestAction = null
    userActions.forEach(action => {
      if (
        latestAction === null ||
        moment(latestAction.date).isBefore(moment(action.date))
      ) {
        if (action.type === 'clockIn' || action.type === 'clockOut') {
          latestAction = action
        }
      }
    })

    if (latestAction === null) {
      return
    }

    return (
      <div className="amountInputRow">
        <div>
          {(latestAction.type === 'clockIn' ? clockinAtText : clockoutAtText) +
            ':'}
        </div>
        <div>{moment(latestAction.date).format('DD MMM YYYY HH:mm')}</div>
      </div>
    )
  }

  getGuestPass = () => {
    const remaining = this.getGuestPassRemaining()
    return (
      <div className="guestPassBlock">
        <div className="amountInputRow">
          <div>{guestPassesRemainingText + ':'}</div>
          <div>{remaining}</div>
        </div>
        {remaining <= 0 && (
          <div className="guestPassNone smallText">{noGuestPassesText}</div>
        )}
      </div>
    )
  }

  render() {
    var image = this.state.selectedUser.user.image
    let token = JSON.parse(window.localStorage.getItem('userData')).token

    if (image !== '') {
      image =
        config.serverURL +
        '/ImageUploads/wackykingdom/download/' +
        image +
        '?access_token=' +
        token
    }

    var guardiansImages = []

    if (
      this.state.selectedUser.selected &&
      this.state.selectedUser.selected.guardians
    ) {
      this.state.selectedUser.user.guardians.forEach(guardian => {
        if (guardian.image !== '') {
          guardiansImages.push(
            config.serverURL +
              '/ImageUploads/wackykingdom/download/' +
              guardian.image +
              '?access_token=' +
              token
          )
        } else {
          guardiansImages.push(guardian.image)
        }
      })
    }

    return (
      <div
        className={
          'checkmemberWindow' + (this.state.shouldClose ? ' closeWindow' : '')
        }>
        <div className="checkmemberForm">
          <IosCloseCircleOutline
            onClick={() => this.animateClose()}
            className="closeIcon"
            fontSize="30px"
            color="#fff"
          />
          <div className="titleText">{checkmemberText}</div>
          {!this.state.selectedUser.selected ? (
            <div className="searchWindow">
              <div className="subtitleText">{pleaseSelectUText}</div>
              <div className="inputWrapper searchBarRow">
                <input
                  type="text"
                  value={this.state.search}
                  disabled={this.props.requestLoading}
                  onChange={e => this.setState({ search: e.target.value })}
                  onKeyDown={e => {
                    if (e.key === 'Enter') this.runSearch()
                  }}
                  placeholder={searchText}
                />
                <div
                  className="buttonWrapper searchButton"
                  onClick={() => this.runSearch()}>
                  {searchText}
                </div>
              </div>
              {this.getSearchItems()}
              <div style={{ height: 30 }}></div>
            </div>
          ) : (
            <div className="searchWrapper selectedWrapper">
              <div className="searchRow smallText selectedRow">
                <div>{this.state.selectedUser.user.email + ''}</div>
              </div>
              {!this.state.paymentDone && (
                <div
                  className="searchChange"
                  onClick={() => this.unselectUser()}>
                  {changeText}
                </div>
              )}
            </div>
          )}
          {this.state.selectedUser.selected && (
            <div>
              <div className="subtitleText">{membershipText}</div>
              {this.state.selectedUser.membership ? (
                <div>
                  <div
                    className="videoWrapper avatarImage"
                    style={{ backgroundImage: "url('" + image + "')" }}></div>
                  <div className="amountInputRow">
                    <div>{memberTypeText + ':'}</div>
                    <div>{this.state.selectedUser.membership.type}</div>
                  </div>
                  <div className="amountInputRow">
                    <div>{memberIntervalText + ':'}</div>
                    <div>
                      {this.state.selectedUser.membership.interval
                        ? this.state.selectedUser.membership.interval
                        : 'N/A'}
                    </div>
                  </div>
                  {this.state.selectedUser.membership.isSibling && (
                    <div className="amountInputRow">
                      <div>{siblingText + ':'}</div>
                      <div>{yesText}</div>
                    </div>
                  )}
                  {this.state.selectedUser.membership.isFamily && (
                    <div className="amountInputRow">
                      <div>{familyPlanText + ':'}</div>
                      <div>{yesText}</div>
                    </div>
                  )}
                  {this.state.selectedUser.membership.isFamily &&
                    this.state.selectedUser.membership.familyChildCount != null && (
                    <div className="amountInputRow">
                      <div>{childrenOnPlanText + ':'}</div>
                      <div>{this.state.selectedUser.membership.familyChildCount}</div>
                    </div>
                  )}
                  <div className="amountInputRow">
                    <div>{startDateText + ':'}</div>
                    <div>
                      {moment(
                        this.state.selectedUser.membership.startDate
                      ).format('DD/MM/YYYY')}
                    </div>
                  </div>
                  <div className="amountInputRow">
                    <div>{statusText + ':'}</div>
                    <div>{this.state.selectedUser.membership.status}</div>
                  </div>
                  <div className="amountInputRow">
                    <div>{referenceText + ':'}</div>
                    <div>{this.state.selectedUser.membership.reference}</div>
                  </div>
                  {this.state.selectedUser.membership.status !== 'active' &&
                    this.getLastPayment()}
                  {this.state.selectedUser.user.guardians.length > 0 && (
                    <div className="subtitleText">{guardiansText}</div>
                  )}
                  {this.state.selectedUser.user.guardians.map(
                    (guardian, index) => {
                      return (
                        <div key={index} className="guardianWrapper">
                          <div
                            className="videoWrapper avatarImage"
                            style={{
                              backgroundImage:
                                "url('" + guardiansImages[index] + "')"
                            }}></div>

                          <div className="amountInputRow">
                            <div>{firstNameText + ':'}</div>
                            <div>{guardian.firstName}</div>
                          </div>
                          <div className="amountInputRow">
                            <div>{lastNameText + ':'}</div>
                            <div>{guardian.lastName}</div>
                          </div>
                        </div>
                      )
                    }
                  )}
                  {this.state.selectedUser.membership.status === 'active' && (
                    <div className="checkButtons">
                      <div
                        className="buttonWrapper extraMargin"
                        onClick={() => this.preview()}>
                        {this.state.previewSelected && this.props.image !== ''
                          ? downloadText
                          : previewText}
                      </div>
                      <div
                        className="buttonWrapper"
                        onClick={() => this.cancel()}>
                        {cancelText}
                      </div>
                    </div>
                  )}
                  {this.getLatestClockIn()}
                  {this.getGuestPass()}
                  <div className="checkButtons">
                    <div
                      className={
                        'buttonWrapper extraMargin' +
                        (this.getGuestPassRemaining() <= 0
                          ? ' buttonWrapperDisabled'
                          : '')
                      }
                      onClick={() => this.updateGuestPass()}>
                      {guestPassUseButtonText}
                    </div>
                    <div
                      className="buttonWrapper extraMargin"
                      onClick={() => this.clockAction('clockOut')}>
                      {clockoutText}
                    </div>
                    <div
                      className="buttonWrapper"
                      onClick={() => this.clockAction('clockIn')}>
                      {clockinText}
                    </div>
                  </div>
                  {this.state
                    .previewSelected /*&& this.props.image !== '' */ && (
                    <div className="cardPreview">
                      <div style={{ height: 20 }}></div>
                      <div className="cardSide frontSide">
                        {/*<div className="cardImage" style={{backgroundImage: "url('" + image +"')"}}></div>
                    <div className="cardDetails">
                      <div className="cardRow">
                        <div>{this.state.selectedUser.user.firstName + ' ' + this.state.selectedUser.user.lastName}</div>
                      </div>
                      <div className="cardRow cardSmall">
                        <div>{this.state.selectedUser.membership.type}</div>
                      </div>
                    </div>*/}
                        <img
                          src={require('./front.png')}
                          className="frontImage"
                          alt="Card front page"
                        />
                      </div>
                      <div style={{ height: 20 }}></div>
                      <div className="cardSide flexColumn cardBackground">
                        <img
                          src={require('./logo.png')}
                          className="logoImage"
                          alt="logo"
                        />
                        <div className="membershipType">
                          <div className="textBold">
                            {this.state.selectedUser.membership.type.toUpperCase()}
                          </div>
                          &nbsp;{membershipBText}
                        </div>
                        <div className="whiteBackground">
                          <img
                            src={this.props.image}
                            className="previewImage"
                            alt="Card barcode"
                          />
                          <div className="cardReference">
                            {this.state.selectedUser.membership.reference}
                          </div>
                        </div>
                        <div className="whiteBackgroundSmall">
                          {this.state.selectedUser.user.firstName +
                            ' ' +
                            this.state.selectedUser.user.lastName}
                        </div>
                        <div className="backsideDetails">
                          <div className="detailsText bold">{termsText}</div>
                          <div className="detailsText">{termsSubText}</div>
                          <div className="detailsMargin"></div>
                          <div className="detailsText bold">{companyText}</div>
                          <div className="detailsText">
                            <div className="bold">{emailText}</div>&nbsp;
                            {' ' + emailAddressText}
                          </div>
                          <div className="detailsText">
                            <div className="bold">{telText}</div>&nbsp;
                            {' ' + telephoneText}
                          </div>
                        </div>
                      </div>
                      {/*<img src={this.props.image} className="previewImage" />
                  <div>{this.state.selectedUser.membership.reference}</div>*/}
                    </div>
                  )}
                  <div className="marginTop"></div>
                </div>
              ) : (
                <div className="amountInputRow marginTop">
                  <div>{noMemberText}</div>
                </div>
              )}
              {!this.state.selectedUser.membership && (
                <div className="checkButtons">
                  <div
                    className="buttonWrapper extraMargin"
                    onClick={() => this.clockAction('clockOut')}>
                    {clockoutText}
                  </div>
                  <div
                    className="buttonWrapper"
                    onClick={() => this.clockAction('clockIn')}>
                    {clockinText}
                  </div>
                </div>
              )}
              {!this.state.selectedUser.membership && this.getLatestClockIn()}
            </div>
          )}
        </div>
        {this.checkForAlert()}
      </div>
    )
  }
}

const mapStateToProps = ({ users, useractions }) => ({
  users: users.users,
  image: users.image,
  useractions: useractions.data,
  recentUsers: users.recentUsers,
  requestFailed: users.requestFailed,
  userForBooking: users.userForBooking,
  requestLoading: users.requestLoading,
  requestFinished: users.requestFinished
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { sendRequest, changeFinished, newUserNotRequired },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Checkmember)
